import { Component, OnInit, Inject, Input } from '@angular/core';
import { MyProfileFormControlsInterface } from './interfaces/my-profile.form-controls.interface';
import { MyProfileFormValues } from './interfaces/my-profile.form-as-json.interface';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserInfo, UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, USER_ROLE, PtlLoginWrapperService, LOGIN_STRATEGY } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { DateService } from 'src/app/shared/services/date.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit {

  @Input() content: { [contentKey: string]: string | boolean } = {
    myProfileTitle: undefined,
    myProfileContent: undefined,
    myProfileInfoTitle: undefined,
    myProfileIsEditAvailable: undefined,
    showFirstName: undefined,
    showLastName: undefined,
    showAddress: undefined,
    showZipCounty: undefined,
    showDob: undefined,
    showGender: undefined,
    showEmail: undefined,
    showPhoneNumber: undefined,
    showPassword: undefined,
    sectionTitle: undefined
  };

  form: UntypedFormGroup;
  isEditMode: boolean;

  isProducerRole: boolean;
  unifiedLoginSettingsUrl: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dateUtility: DateService,
    private reducerUtilityService: ReducerUtilityService,
    private ptlLoginWrapper: PtlLoginWrapperService
  ) {
    this.form = this.fb.group({
      firstName: this.fb.control('-'),
      lastName: this.fb.control('-'),
      addressLine1: this.fb.control('-'),
      addressLine2: this.fb.control('-'),
      zipCode: this.fb.control('-'),
      county: this.fb.control('-'),
      city: this.fb.control('-'),
      state: this.fb.control('-'),
      dateOfBirth: this.fb.control('-'),
      gender: this.fb.control('-'),
      emailAddress: this.fb.control('-'),
      phoneNumber: this.fb.control('-'),
      password: this.fb.control('********')
    });
    this.form.disable();
  }

  ngOnInit() {
    const userData: UserInfoStateStructure
      = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    this.isProducerRole = (
      userData.basicUserInfo.userType.toLowerCase() === USER_ROLE.AGENT ||
      userData.basicUserInfo.userType.toLowerCase() === USER_ROLE.INTERNAL ||
      userData.basicUserInfo.userType.toLowerCase() === USER_ROLE.AGENCY_ADMIN
    );

    const userInfo: UserInfo = userData.userInfo;

    this.form.patchValue({
      firstName: userInfo.firstName || '-',
      lastName: userInfo.lastName || '-',
      addressLine1: userInfo.address || '-',
      addressLine2: '-',
      zipCode: userInfo.zipCode || '-',
      county: '-',
      city: userInfo.city || '-',
      state: userInfo.state || '-',
      dateOfBirth: userInfo.dob ? this.dateUtility.getDateAsFormattedString(userInfo.dob, 'MM/DD/YYYY') : '-',
      gender: userInfo.gender || '-',
      emailAddress: userInfo.email || '-',
      phoneNumber: userInfo.home_phone || userInfo.telephone || '-'
    });

    this.content.showFirstName =  this.fromStringToBool(this.content.showFirstName as string);
    this.content.showLastName = this.fromStringToBool(this.content.showLastName as string);
    this.content.showAddress = this.fromStringToBool(this.content.showAddress as string);
    this.content.showZipCounty = this.fromStringToBool(this.content.showZipCounty as string);
    this.content.showDob = this.fromStringToBool(this.content.showDob as string);
    this.content.showGender = this.fromStringToBool(this.content.showGender as string);
    this.content.showEmail = this.fromStringToBool(this.content.showEmail as string);
    this.content.showPhoneNumber = this.fromStringToBool(this.content.showPhoneNumber as string);
    this.content.showPassword = this.fromStringToBool(this.content.showPassword as string);
    

    this.ptlLoginWrapper.currentLoginStrategy.subscribe((strategy) => {
      if (strategy === LOGIN_STRATEGY.UNIFIED_LOGIN_SSO) {
        let baseUrl = environment.infrastructure.oauth.baseUrl;
        let clientId = environment.infrastructure.oauth.client_id;
        this.unifiedLoginSettingsUrl = `${baseUrl}/manage-account?client_id=${clientId}`;
      }
    });
  }

  fromStringToBool(v: string): boolean {
    return v?.toUpperCase() === "TRUE";
  }

  get formControls(): MyProfileFormControlsInterface {
    return this.form.controls as unknown as MyProfileFormControlsInterface;
  }

  get formValuesAsJson(): MyProfileFormValues {
    return this.form.value as MyProfileFormValues;
  }
}
